<div class="cnt-page-internal">
    <teiasoft-toolbar [buttonsList]="buttonsList" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)"
        style="width: 100%;"></teiasoft-toolbar>
    <teiasoft-grid *ngIf="isLoaded" style="width:100%" [title]="'groups'" [columnsToHide]="columnsToHide" [gridDescription]="'users.groups' | translate"
        [columnsToShow]="columnsToShow" [dataSet]="groupsForGrid" [showFooter]="false" [selectable]="false"
        [disableAllSelection]="true" [theme]="globals.theme!" [autoWidth]="true" [showEditIcon]="false"
        [minWidthVw]="minWidthVw" [dateFormat]="globals.dateFormat!" [dateTimeFormat]="globals.dateTimeFormat!"
        [customIcoCols]="customIcoCols" (customIconClick)="customIconClick($event)" [filterable]="false"
        [gridName]="'groups'" [fullFilter]="true" [openFilter]="openFilter" (imFiltering)="imFiltering($event)"
        [clearFilters]="clearFilters" [maxHeightVh]="70" ></teiasoft-grid>
</div>

<!-- CONFIRM  MODAL -->
<teiasoft-modal (onConfirmClick)="onConfirmModal($event)" [theme]="globals.theme!"
    [isMobile]="!globals.isDesktop!"></teiasoft-modal>

<!-- MODAL GROUP -->
<app-modal-group *ngIf="showModalGroup" [action]="action" [groupId]="groupIdToEdit" [authInfo]="authInfo"
    (closeModalGroup)="closeModalGroup($event)"></app-modal-group>